import { render, staticRenderFns } from "./client_capturados.vue?vue&type=template&id=55dd9ac5&"
import script from "./client_capturados.vue?vue&type=script&lang=js&"
export * from "./client_capturados.vue?vue&type=script&lang=js&"
import style0 from "./client_capturados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports